import * as React from 'react'
import Select from 'react-select'
import {RegHistory} from './RegHistory'
import {StreetHistory} from './StreetHistory'

interface State {
  type: string
}

interface Props {}

export class HistoryTypeSelector extends React.Component<Props, State> {
  state = {
    type: 'reg'
  }
  getSelector() {
    const defValue = {value: 'reg', label: 'Регулации'}
    const options: {value: any; label: any}[] = [defValue, {value: 'street', label: 'Улични регулации'}]
    let currentValue: {value: any; label: any} = defValue
    for (let i = 0; i < options.length; i++) {
      if (options[i].value == this.state.type) {
        currentValue = options[i]
      }
    }
    return (
      <Select
        className="Select-class-10"
        isSearchable={true}
        value={currentValue}
        placeholder={`Изберете местност`}
        onChange={(newValues: any) => {
          this.setState({...this.state, type: newValues.value})
        }}
        options={options}
      />
    )
  }
  render() {
    return (
      <div
        style={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <div style={{padding: '4px 10px 4px 10px'}}>{this.getSelector()}</div>
        {this.state.type == 'reg' ? <RegHistory /> : <StreetHistory />}
      </div>
    )
  }
}
